import { component } from "picoapp";
import { getHashFilter, handleize } from "../lib/utils";

export default component(async (node, ctx) => {
  const { default: Isotope } = await import("isotope-layout");

  let grid = "";
  let isIsotopeInit = false;
  const buttonFilters = node.querySelectorAll("button[data-filter]");

  // init filter buttons
  buttonFilters.forEach((button) => {
    button.addEventListener("click", () => {
      location.hash = `filter=.${handleize(button.dataset.filter)}`;
      button.querySelector(".is-checked")?.classList.remove("is-checked");
      button
        .querySelector(".is-checked")
        ?.setAttribute("aria-current", "false");
      button?.setAttribute("aria-current", "true");
      button.classList.add("is-checked");
    });
  });

  function renderGrid(hashFilter) {
    const gridSection = node.querySelector("[data-grid]");

    grid = new Isotope(gridSection, {
      itemSelector: "[data-grid-item]",
      layoutMode: "fitRows",
      filter: hashFilter,
    });

    grid.on("arrangeComplete", () => {
      ctx.emit("product-card:updateAll");
    });

    grid.on("layoutComplete", () => {
      node.classList.remove("hide-init");
    });
  }

  function onHashchange() {
    const { hash } = window.location;
    if (!hash) {
      const filter = node.querySelector("[data-filter]").dataset.filter;
      window.location.hash = `#filter=.${filter}`;
    }
    const hashFilter = getHashFilter();
    ctx.hydrate({ filter: hashFilter.slice(1) });

    const collectionTextBanners = node.querySelectorAll("[data-banner]");
    collectionTextBanners.forEach((collectionTextBanner) => {
      if (collectionTextBanner.dataset.collection === hashFilter.slice(1)) {
        collectionTextBanner.classList.remove("hide");
      } else {
        collectionTextBanner.classList.add("hide");
      }
    });

    if (hashFilter) {
      buttonFilters.forEach((button) => {
        button.classList.remove("is-checked");
        button.setAttribute("aria-current", "false");
      });

      const selectedFilterElement = Array.from(buttonFilters).find(
        (button) => button.dataset.filter === hashFilter.slice(1)
      );
      if (selectedFilterElement) {
        selectedFilterElement.classList.add("is-checked");
        selectedFilterElement.setAttribute("aria-current", "true");
      }

      if (!isIsotopeInit) {
        renderGrid(hashFilter);
        isIsotopeInit = true;
      }

      grid.arrange({ filter: hashFilter });
    }
  }

  window.addEventListener("hashchange", onHashchange);

  // trigger event handler to init Isotope
  onHashchange();
});
